<template>
  <div>
    <PaginaTitulo sticky titulo="MONITORAMENTO" subTitulo="Gerencie e monitore os seus produtos">
      <CounterNcm
        :contadorAtual="produtosLength"
        :contadorTotal="assinatura_qtde_produto"
        tituloTooltipCheio="Limite de Produtos monitorados atingido."
        tituloTooltip="Total de Produtos do Plano contratado."
        legenda="Produtos monitorados"
      />
    </PaginaTitulo>
    <div class="container conteudo-principal">
      <div class="form-wrapper-monitoria">
        <div class="form-monitoria">
          <div>
            <div class="input-monitoria">
              <font-awesome-icon icon="search" />
              <CenarioInput
                placeholder="Pesquisar em Monitoramento"
                class="input-pesquisar"
                tipo="texto"
                :model="strPesquisa"
                @update:model="update => (strPesquisa = update)"
              />
            </div>
          </div>
        </div>
        <div class="botao-linha-monitoria">
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-padding"
            nome="E-mail"
            icone="cog"
            :click="linkEmail"
            :loading="blLoadingAdicionar"
            :desabilita="blLoading || !getEmpresa.id"
            :tooltip="!getEmpresa.id ? 'Selecione uma empresa' : 'Configurar E-mails'"
          />
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-padding"
            nome="Histórico de Alterações"
            icone="history"
            :click="linkMonitoria"
            :loading="blLoadingAdicionar"
            :desabilita="blLoading || !getEmpresa.id"
            :tooltip="!getEmpresa.id ? 'Selecione uma empresa' : ''"
          />
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-padding"
            nome="Adicionar"
            icone="plus"
            :click="adicionarProdutoMonitoria"
            :loading="blLoadingAdicionar"
            cor="azul"
            :desabilita="blLoading || !getEmpresa.id"
            :tooltip="!getEmpresa.id ? 'Selecione uma empresa' : ''"
          />
        </div>
      </div>
      <div v-if="blLoading">
        <LoadingPadraoContainer
          :fraseLoading="[
            'Carregando Produtos Monitorados',
            'Aguarde um momento',
            'Consultando banco de dados'
          ]"
          classe="azul"
          :delay="'7000'"
        />
      </div>
      <TabelaPaginada
        v-if="
          !blLoading && produtosMonitorados.length > 0 && getEmpresa.id && groupedItems.length != 0
        "
        @atualizaProdutos="listarProdutos"
        @ordenar="ordenar"
        @editarProduto="editarProdutoMonitoria"
        monitoria
        :blBigData="blBigData"
        :conteudo="groupedItems"
      />
      <SinosLegenda
        v-if="
          !blLoading && produtosMonitorados.length > 0 && getEmpresa.id && groupedItems.length != 0
        "
      />
      <MensagemSemResultados
        v-if="!getEmpresa.id"
        :mensagem="'Selecione uma empresa para exibir os produtos monitorados.'"
      />
      <MensagemSemResultados
        v-if="groupedItems.length == 0 && getEmpresa.id && blLoading === false"
        :mensagem="'Nenhum produto monitorado.'"
      />
      <ModalProduto
        @atualiza="listarProdutos()"
        @adicionar="() => (tituloModalProduto = 'adicionar')"
        :titulo="tituloModalProduto"
        :produtoData="editarProdutoData"
        :atualizaModal="atualizaModal"
        :produtosCadastrados="produtoCadastrados"
        :produtosLength="produtosQuantidade"
      />
    </div>
  </div>
</template>

<script>
import Api from "@/services/api.js";
import vLoader from "@/components/Loader.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import MensagemSemResultados from "@/components/MensagemSemResultados/MensagemSemResultados.vue";
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import ModalProduto from "@/components/ModalProduto/ModalProduto.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import SinosLegenda from "../../components/Sinos/SinosLegenda.vue";
import stringFormatMixin from "@/mixins/stringFormatMixin";
import TabelaPaginada from "../TabelaPaginada/TabelaPaginada.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ProdutoMonitoria",
  inject: ["pushAlert"],
  data() {
    return {
      produtosLength: null,
      assinatura_qtde_produto: 10,
      blLoadingAdicionar: false,
      blLoading: false,
      tituloModalProduto: "",
      editarProdutoData: null,
      atualizaModal: false,
      strPesquisa: "",
      quantidadePaginacao: -1,
      reverse: false,
      // blBigData:false,
      blLoadingFiltrar: false,
      produtoCadastrados: [],
      produtosMonitorados: [],
      produtosQuantidade: 0
    };
  },
  mixins: [stringFormatMixin],
  components: {
    CounterNcm,
    BotaoPadrao,
    SinosLegenda,
    vLoader,
    MensagemSemResultados,
    ModalProduto,
    CenarioInput,
    TabelaPaginada,
    PaginaTitulo,
    LoadingPadraoContainer
  },
  beforeDestroy() {
    this.setBlBigData(false);
  },
  mounted: function() {
    //this.listaProdutosEmpresa();
    let testAssinatura = localStorage.getItem("assinatura");
    if (
      testAssinatura &&
      testAssinatura !== undefined &&
      testAssinatura !== "undefined" &&
      testAssinatura != null
    ) {
      var dadosAssinatura = JSON.parse(localStorage.getItem("assinatura"));

      this.assinatura_plano = dadosAssinatura.nome_plano;
      this.assinatura_qtde_produto = parseInt(dadosAssinatura.qtde_produto);

      if (typeof this.assinatura_qtde_produto == "undefined") {
        this.assinatura_qtde_produto = 10;
      }
    }
    if (!!this.getEmpresa.id) {
      this.listarProdutos();
    }
    // this.quantidadePaginacaoBack();
    this.quantidadeProdutosSemMonitoria();
    this.quantidadeProdutos();

    this.listarProdutosCadastrados();
  },
  computed: {
    ...mapGetters("empresa", {
      getEmpresa: "getEmpresa"
    }),
    ...mapGetters("loading", {
      blBigData: "getBlBigData"
    }),

    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    // blUsuarioPro() {
    //   return true;
    // },

    ...mapGetters("login", {
      getAssinatura: "getAssinatura"
    }),

    produtosFiltrados() {
      if (this.strPesquisa != "") {
        const filtro = this.produtosMonitorados.filter(
          f =>
            this.removerAcentos(f.nome.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.ncm
              .toLowerCase()
              .replaceAll(".", "")
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.ncm.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.data_alteracao
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.data_alteracao.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            )
        );

        return filtro;
      } else {
        return this.produtosMonitorados;
      }
    },
    groupedItems() {
      if (this.produtosFiltrados.length > 0) {
        return this.groupBy(Object.values(this.produtosFiltrados));
      }
      return [];
    }
  },
  watch: {
    getEmpresa(newVal, oldVal) {
      this.opened = [];
      if (newVal.id != oldVal.id && !!this.getEmpresa.id) {
        this.produtosMonitorados = [];
        // this.quantidadePaginacaoBack();
        this.listarProdutos();
        this.quantidadeProdutos();
        this.strPesquisa = "";
        this.listarProdutosCadastrados();
      }
    }
  },
  methods: {
    async quantidadeProdutosSemMonitoria() {
      this.produtosQuantidade = null;
      let response = await new Api().get("Produto/retornaQuantidadeProdutos");
      var dados = response.dados;
      this.produtosQuantidade = parseInt(dados.produtos);
    },
    linkEmail() {
      this.$root.$emit("bv::show::modal", "ModalEmail");
    },
    ...mapActions("loading", ["setBlBigData"]),

    updateBlBigData(newValue) {
      this.setBlBigData(newValue);
    },
    quantidadePaginacaoBack() {
      if (this.getEmpresa.id) {
        new Api()
          .get("/Produto/obterProdutosMonitoriaRefactoryTotal/" + this.getEmpresa.id)
          .then(response => {
            var dados = response.dados;
            this.quantidadePaginacao = dados[0].total;
          });
      }
    },

    linkEmail() {
      this.$root.$emit("bv::show::modal", "ModalEmail");
    },
    listarProdutos() {
      this.quantidadePaginacaoBack();
      this.quantidadeProdutosSemMonitoria();
      this.produtosMonitorados = [];
      const itensPorPagina = 5000;
      const empresaId = this.getEmpresa.id;
      // const empresaId = 12117;

      if (!empresaId || empresaId === "0") {
        this.blLoading = false;
        return false;
      }

      this.blLoading = true;
      this.updateBlBigData(true);
      const obterProdutosPorPagina = pagina => {
        new Api()
          .get(
            `Produto/obterProdutosMonitoriaRefactoryPaginacao/${pagina}/${itensPorPagina}/${empresaId}`
          )
          .then(response => {
            this.produtosMonitorados = [...this.produtosMonitorados, ...response.dados];
            this.blLoading = false;
            var paginacao = parseInt(pagina) + parseInt(itensPorPagina);
            if (this.quantidadePaginacao > itensPorPagina) {
              this.updateBlBigData(true);
              if (this.quantidadePaginacao > paginacao) {
                obterProdutosPorPagina(paginacao);
              } else {
                this.updateBlBigData(false);
              }
            } else {
              this.updateBlBigData(false);
            }
          })
          .catch(error => {
            console.error(error);
            this.blLoading = false;
          });
      };

      obterProdutosPorPagina(0);
    },
    adicionarProdutoMonitoria() {
      this.tituloModalProduto = "adicionar_monitoria";
      this.editarProdutoData = null;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    groupBy(array) {
      return array.reduce((acc, item) => {
        let key = item.ncm + item.ex;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
    },

    quantidadeProdutos() {
      new Api().get("/Produto/obterProdutosUsuario").then(response => {
        var dados = response.dados;
        this.produtosLength = parseInt(dados.produtos);
      });
    },
    linkMonitoria() {
      this.$router.push("/monitoria");
    },
    editarProdutoMonitoria(prod) {
      this.tituloModalProduto = "monitoria";
      this.editarProdutoData = prod;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    ordenar(strOrdem) {
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        this.produtosFiltrados.reverse();
        return;
      }
      this.reverse = false;
      this.produtosFiltrados.sort((a, b) => {
        if (
          a[strOrdem] == "-" ||
          a[strOrdem] == "" ||
          a[strOrdem] == "0" ||
          b[strOrdem] == "-" ||
          b[strOrdem] == "" ||
          b[strOrdem] == "0"
        ) {
          return a[strOrdem] == "-" || a[strOrdem] == "" || a[strOrdem] == "0" ? 1 : -1;
        }
        return a[strOrdem].localeCompare(b[strOrdem]);
      });

      this.strOrdem = strOrdem;
    },

    adicionarProdutoMonitoria() {
      this.tituloModalProduto = "adicionar_monitoria";
      this.editarProdutoData = null;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    listarProdutosCadastrados() {
      if (
        !this.getEmpresa ||
        Object.keys(this.getEmpresa).length == 0 ||
        (this.getEmpresa && !this.getEmpresa.id)
      ) {
        this.produtoCadastrados = [];
        return;
      }
      new Api().get("Produto/obterProdutosEmpresa/" + this.getEmpresa.id).then(response => {
        if (!response) {
          this.produtoCadastrados = [];
          return;
        }
        if (response.dados) {
          this.produtoCadastrados = response.dados.filter(f => f.vigente == 1 && f.ncm.length >= 8);
        } else {
          this.produtoCadastrados = [];
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-remover-monitoria {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.remover-mensagem {
  text-align: center !important;
  display: flex;
  justify-content: center;
}
.input-wrapper-monitoria {
  margin-bottom: 15px;
  width: 100%;
  // padding-bottom: 15px;
  position: relative;
  max-width: 400px;
  input {
    box-shadow: 2px 2px 4px #00000020;
    height: 30px !important;
    width: 100%;
    float: left;
    border-radius: 2px;
    border: 1px solid rgba(60, 60, 60, 0.26);
    color: #333;
    background: #fdfdfd;
    padding: 5px 11px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    padding: 6px 10px;
    height: 32px;
    border-radius: 0;
  }
}
.form-wrapper-monitoria {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 15px;
}
.botao-linha-monitoria {
  display: flex;
}

.titulo-pagina {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-pesquisar {
  border-radius: 2px;
  color: #333;
  background: #fdfdfd;
  transition: all 0.3s ease;
  margin-left: 10px;
  width: 100%;
}
.input-container-monitoria {
  margin-bottom: 10px;
}
.input-monitoria {
  display: flex;
  align-items: center;
  width: 400px;
}
.conteudo-principal {
  max-width: 1155px;
  h1 {
    margin-top: 0 !important;
    padding: 20px;
  }
}
</style>
